var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    id: "india",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f93",
    d: "M0 0h640v160H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 160h640v160H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#128807",
    d: "M0 320h640v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2 0 0 3.2 320 240)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#008"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.875,
    transform: "rotate(7.5 -8.75 133.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5.6 7 0 2l-.6 5L0 17.5z"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(15)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(30)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(60)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(120)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(-120)",
    xlinkHref: "#d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.7428810fec8df0e6759f23f4112cf710.svg";
export { ForwardRef as ReactComponent };